/**
 * User-facing copy for multitenant financial institutions (banks, MFIs, credit unions, SACCOs, etc.).
 * API fields and model names stay unchanged — only labels, hints, and messages use this module.
 */

export const INSTITUTION_TERMS = {
  organization: 'organization',
  Organization: 'Organization',
  customerAccount: 'customer account',
  customerAccounts: 'customer accounts',
  CustomerAccounts: 'Customer accounts',
  accountHolder: 'account holder',
  staff: 'staff',
  dataOnboarding: 'Data onboarding',
  onboardingWizard: 'Data onboarding wizard',
  onboardingInProgress: 'Data onboarding in progress',
  noOrganizationSelected: 'No organization selected. Please log in again.',
  goLive: 'Your organization is live',
};

export default INSTITUTION_TERMS;
